import { FC } from "react";
import Logo from "../../icons/logo.svg";
import SuccessTick from "../../icons/success.svg";
import { TransactionDetailsType } from "./types";

const PaymentSuccess: FC<TransactionDetailsType> = ({
  amount,
  paymentType,
  transactionNo,
  status,
  applicationNo,
}): JSX.Element => {
  return (
    <>
      {
        <div className="flex flex-col items-center justify-center m-auto h-screen">
          <div id="logo" className="flex items-center justify-center h-1/6 ">
            <img src={Logo} alt="NHL Logo" />
          </div>
          <div className="h-[15%]" id="successTick">
            <img src={SuccessTick} alt="success" className="h-3/4" />
          </div>
          <div
            className="flex flex-col h-[30%] lg:h-[40%] w-11/12  sm:w-8/12 "
            id="detailsTable"
          >
            <div className="flex flex-row w-full border-b border-grey-600 pb-2 pt-2">
              <div className="flex w-1/2 pl-2 text-slate-500">
                Application No.
              </div>
              <div className="flex w-1/2 justify-end pr-2">{applicationNo}</div>
            </div>
            <div className="flex flex-row w-full border-b border-grey-600 pb-2">
              <div className="flex w-1/2 pl-2 text-slate-500">Payment Type</div>
              <div className="flex w-1/2 justify-end pr-2 text-right">
                {paymentType.includes("ServiceRequest")
                  ? "Service Request Fee"
                  : "Fee"}
              </div>
            </div>
            <div className="flex flex-row w-full border-b border-grey-600 pb-2">
              <div className="flex w-1/2 pl-2 text-slate-500">
                Amount(incl. VAT 5%)
              </div>
              <div className="flex w-1/2 justify-end pr-2 mt-1"><><img src='/DirhamCurrencySymbolBlack.png' className="h-[13px] w-[13px] mt-[6.5px] mr-[4px]" alt="AED" />{` ${amount}`}</></div>
            </div>
            <div className="flex flex-row w-full border-b border-grey-600 pb-2">
              <div className="flex w-1/2 pl-2 text-slate-500">
                Transaction No.
              </div>
              <div className="flex w-1/2 justify-end pr-2">{transactionNo}</div>
            </div>
            <div className="flex flex-row w-full border-b border-grey-600 pb-2">
              <div className="flex w-1/2 pl-2 text-slate-500">Status</div>
              <div className="flex w-1/2 justify-end pr-2">Paid</div>
            </div>
          </div>
          <div
            className="flex justify-center h-1/5 w-full pt-4"
            id="actionButtons"
          >
            <button
              onClick={window.print}
              className="border-blue-600 border rounded-sm w-[6rem] border-solid h-10 text-blue-600"
            >
              Print
            </button>
          </div>
        </div>
      }
    </>
  );
};

export default PaymentSuccess;
